import React from "react";
import { Button, Card } from "react-bootstrap";

import { IPermissionConfig } from "../../config/interfaces";
import GuardedComponent from "../GuardedComponent";

type Props = {
  message: string;
  title?: string;
  btnTitle?: string;
  onBtnPress?: () => void;
  btnRules?: IPermissionConfig | undefined;
  variant?: string;
};

const NothingAvailable: React.FC<Props> = (props: Props) => {
  const { message, title, btnTitle, onBtnPress, btnRules = undefined, variant = "white" } = props;

  return (
    <Card className="nothing-available-card" bg={variant}>
      <Card.Body>
        {title && <h1 className="text-center mb-3">{title}</h1>}
        <Card.Title>{message}</Card.Title>
        {btnTitle ? (
          <GuardedComponent rules={btnRules} behavior="hide">
            <Button
              variant="secondary"
              className="btn-w-200"
              onClick={() => (onBtnPress ? onBtnPress() : null)}
            >
              {btnTitle}
            </Button>
          </GuardedComponent>
        ) : null}
      </Card.Body>
    </Card>
  );
};

export default NothingAvailable;
